import { ChargeWaiverRepoImpl } from "domain/repository/ChargeWaiver/ChargeWaiverRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { useChargeWaiverTracked } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { ChargeWaiverVM } from "presentation/viewModel/ChargeWaiver/ChargeWaiverVM";
import { useMemo } from "react";

export const useChargeWaiverVM = () => {
    const [, setChargeWaiverState] = useChargeWaiverTracked();
    const chargeWaiverVM = useMemo(() =>
        ChargeWaiverVM({
            dispatch: [setChargeWaiverState],
            chargeWaiverRepo: ChargeWaiverRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
        }), [setChargeWaiverState])

    return chargeWaiverVM
}

